import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          读者热议
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          百万漫迷的真实评价，一起加入古古的漫画社区
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {commentItems.slice(0, 5).map((item, i) => (
            <div
              key={i}
              className={`bg-background-100 rounded-xl border border-background-200/70 p-5 flex flex-col gap-3 transition-all duration-200 hover:border-primary-200 ${
                i >= 3 ? 'lg:col-span-1 md:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 border-2 border-background-200">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
              <div className="flex items-center gap-2 pt-1 border-t border-background-200/50">
                <i className="ri-book-open-line text-xs text-primary-400" />
                <span className="text-xs text-primary-500 font-medium">{item.manga}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}